import { fetchSafe } from './fetch.safe';

function version() {
    return fetchSafe('/api/build')
}

export const buildService = {
    version
};
